import axios from "axios";
import AlertService from "./AlertService";
const api = axios.create();
export const apiRaw = axios.create();
api.interceptors.response.use((response) => {
    return response;
}, (error) => {
    const response = error.response;
    let msg = "";
    switch (response.status) {
        case -1:
            //A requisição foi cancelada..
            break;
        case 401:
            //requisição inválida
            alert("A sua sessão expirou. Efetue login novamente para acessar o sistema.");
            window.location.href = "login";
            break;
        case 403:
            //acesso negado
            msg = response.data.error;
            AlertService.error(msg, "Operação não permitida", 10000);
            break;
        case 405:
            //acesso negado
            msg = response.data.message;
            AlertService.error(msg, "Operação não permitida", 10000);
            break;
        case 422:
            //entidade não processada - erros de validação
            var erros = "";
            msg = response.data.mensagem
                ? response.data.mensagem
                : response.data.msg;
            if (typeof response.data != "string" && typeof msg != "string") {
                Object.values(response.data).forEach((value) => {
                    for (var j = 0; j < value.length; j++) {
                        erros += value[j] + "<br>";
                    }
                });
            }
            else {
                erros += msg ? msg : response.data;
            }
            AlertService.error(erros, "Atenção!", 10000);
            break;
        default:
            //erro interno no servidor
            msg = "Erro " + response.status + ": " + response.statusText;
            AlertService.error(msg, "Erro ao processar requisição!", 10000);
            break;
    }
    return Promise.reject(error);
});
export default api;
